import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { XIcon, CheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
export function PromoPopup() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const {
    t,
    lang
  } = useTranslation();
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 6000);
    return () => clearTimeout(timer);
  }, []);
  if (!visible || dismissed) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center px-4" data-id="element-277">
      <div className="absolute inset-0 bg-black bg-opacity-70 backdrop-blur-sm" onClick={() => setDismissed(true)} data-id="element-278" />
      <div className="relative z-10 bg-dark-surface border border-dark-border rounded-industrial max-w-lg w-full shadow-2xl overflow-hidden" data-id="element-279">
        <div className="h-1 w-full bg-brand-yellow" data-id="element-280" />
        <div className="p-7 md:p-9" data-id="element-281">
          <button onClick={() => setDismissed(true)} className="absolute top-5 right-5 text-gray-500 hover:text-white transition-colors" aria-label="Zatvori" data-id="element-282">
            <XIcon className="w-5 h-5" data-id="element-283" />
          </button>

          <div className="inline-block bg-brand-yellow text-dark-bg text-xs font-black uppercase tracking-widest px-3 py-1 rounded mb-5" data-id="element-284">
            {t.popup.badge}
          </div>

          <h3 className="text-2xl md:text-3xl font-black text-white leading-tight mb-4" data-id="element-285">
            {t.popup.title}
          </h3>

          <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-4" data-id="element-286">
            {t.popup.body}
          </p>

          <ul className="space-y-2 mb-6" data-id="element-287">
            {[lang === 'en' ? 'Longer runtime' : lang === 'ru' ? 'Более длительное время работы' : 'Duža autonomija rada', lang === 'en' ? 'No waiting for charging' : lang === 'ru' ? 'Без ожидания зарядки' : 'Bez čekanja na punjenje', lang === 'en' ? 'Always ready for work' : lang === 'ru' ? 'Всегда готовы к работе' : 'Uvek spremni za rad'].map((item, idx) => <li key={idx} className="flex items-center text-sm text-gray-300" data-id="element-288">
                <CheckIcon className="w-4 h-4 text-brand-yellow mr-2 flex-shrink-0" data-id="element-289" />
                {item}
              </li>)}
          </ul>

          <p className="text-gray-400 text-sm mb-6 border-t border-dark-border pt-4 mt-4" data-id="element-290">
            {t.popup.avans}
          </p>

          <div className="flex flex-col gap-3" data-id="element-291">
            <Button variant="primary" size="lg" className="w-full" onClick={() => {
            setDismissed(true);
            navigate('/products');
          }} data-id="element-292">
              {t.popup.btnPrimary}
            </Button>
          </div>
        </div>
      </div>
    </div>;
}